import { Box, Skeleton } from '@mui/material';


export default function LoadingSkeleton() {
    return (
        <Box m={2}>
            <Skeleton animation="wave" variant="rectangular" width={210} />
            <Box sx={{ pt: 0.5 }}>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" width="60%" />
            </Box>
            <Box sx={{ pt: 0.5 }}>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" width="60%" />
            </Box>
            <Box sx={{ pt: 0.5 }}>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" width="100%" />
                <Skeleton animation="wave" width="100%" />
                <Skeleton animation="wave" width="100%" />
                <Skeleton animation="wave" width="100%" />
            </Box>
        </Box>
    )
}

